import { useMutation } from 'react-query'

import { scanToEarnService } from 'src/services/scan-to-earn.service'

export const useDownloadNotRecognizedImpactsCsv = () => {
  return useMutation(() => scanToEarnService.getNotRecognizedImpactsCsv(), {
    onSuccess: (data) => {
      // Create a Blob from the CSV data
      if (!data) {
        return
      }
      const blob = new Blob([data], { type: 'text/csv' })
      const url = window.URL.createObjectURL(blob)

      // Create an anchor element and trigger a download
      const a = document.createElement('a')
      a.href = url
      a.download = `not_recognized_impacts_${new Date().toLocaleDateString('en-US')}.csv`
      document.body.appendChild(a)
      a.click()

      a.remove()
      window.URL.revokeObjectURL(url)
    },
    onError: (error) => {
      console.error('CSV download failed:', error)
    },
  })
}
